import { Component, OnInit } from '@angular/core';
import { IdleService } from '../services/idle.service';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-layout',
    templateUrl: './app.layout.component.html',
    styleUrl: './app.layout.component.scss'
})
export class AppLayoutComponent implements OnInit {

    constructor(private idleService: IdleService, private authService:AuthService) { }
    ngOnInit(): void {
       if(!this.authService.expiresIn){
        this.authService.refreshToken().subscribe({
            next: (res) => {
              this.authService.setToken(res.refresh_token);
              this.authService.expiresIn=res.expires_in;
              this.idleService.setIdleTimeout(this.authService.expiresIn);
            },
            error:(e)=>{
                this.authService.logout();
            }
          })
       }else{
            this.idleService.setIdleTimeout(this.authService.expiresIn);
       }
    }

    get showDialog(): boolean {
        return this.idleService.showDialog;
    }

    get idleCount(): number {
        return this.idleService.idleCountDown;
    }
}
